import React from 'react'
import Modal from '../../../components/Modal'
import { formatMoney } from '../utils/paymentHelpers'

export function SalaryDetailModal({
  salaryDetailModal,
  setSalaryDetailModal,
  isAdmin,
  profile,
  handleEdit,
  setItemToDelete,
  setDisputeId
}) {
  return (
    <Modal
      isOpen={!!salaryDetailModal}
      onClose={() => setSalaryDetailModal(null)}
      title={salaryDetailModal?.title || 'Детализация'}
      isBottomSheet={true}
    >
      {salaryDetailModal && (
        <div className="salary-detail-modal">
          {salaryDetailModal.items.length === 0 ? (
            <div style={{ padding: '20px', textAlign: 'center', color: 'var(--text-secondary)' }}>
              Нет записей за выбранный период
            </div>
          ) : (
            <div className="salary-detail-list">
              {salaryDetailModal.items.map((item, idx) => (
                <div key={idx} className="salary-detail-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '12px 0', borderBottom: '1px solid var(--border-color)' }}>
                  <div className="salary-detail-item-left" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span className="salary-detail-item-icon">{item.icon}</span>
                    <div>
                      <div className="salary-detail-item-name" style={{ fontWeight: 600 }}>{item.name}</div>
                      {item.date && <div className="salary-detail-item-date" style={{ fontSize: '11px', color: 'var(--text-secondary)', marginTop: '2px' }}>{item.date}</div>}
                      {item.comment && <div className="salary-detail-item-comment" style={{ fontSize: '12px', fontStyle: 'italic', color: 'var(--text-secondary)', marginTop: '2px' }}>{item.comment}</div>}
                    </div>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span className={`salary-detail-item-amount ${item.isNegative ? 'negative' : 'positive'}`} style={{ fontWeight: 700, color: item.isNegative ? 'var(--danger)' : 'var(--success)' }}>
                      {item.isNegative ? '−' : '+'}{formatMoney(Math.abs(item.amount))}
                    </span>
                    
                    {/* Управление для владельца/администратора */}
                    {isAdmin && item.rawRecord && (
                      <div style={{ display: 'flex', gap: '4px' }}>
                        {item.rawRecord.type !== 'salary' && (
                          <button 
                            className="btn btn-ghost btn-sm" 
                            style={{ padding: '4px', minHeight: 'auto', height: 'auto', display: 'flex' }}
                            onClick={() => {
                              setSalaryDetailModal(null);
                              handleEdit(item.rawRecord);
                            }} 
                            title="Редактировать"
                          >
                            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
                          </button>
                        )}
                        <button 
                          className="btn btn-ghost btn-sm" 
                          style={{ padding: '4px', minHeight: 'auto', height: 'auto', color: 'var(--danger)', display: 'flex' }}
                          onClick={() => {
                            setSalaryDetailModal(null);
                            setItemToDelete({ id: item.rawRecord.id, source: item.rawRecord._source });
                          }} 
                          title="Удалить"
                        >
                          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><polyline points="3 6 5 6 21 6"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/></svg>
                        </button>
                      </div>
                    )}

                    {/* Оспаривание для сотрудников */}
                    {item.rawRecord && item.rawRecord.employee_id === profile?.id && (item.rawRecord.type === 'fine' || item.rawRecord._source === 'deduction') && item.rawRecord.status !== 'disputed' && item.rawRecord.status !== 'rejected' && (
                      <button 
                        className="btn btn-outline btn-sm" 
                        style={{ fontSize: '11px', padding: '4px 8px', color: 'orange', borderColor: 'orange', minHeight: 'auto', height: 'auto', borderRadius: '6px' }}
                        onClick={() => {
                          setSalaryDetailModal(null);
                          setDisputeId({ id: item.rawRecord.id, source: item.rawRecord._source });
                        }}
                      >
                        Оспорить
                      </button>
                    )}

                    {/* Метка оспаривания для сотрудников */}
                    {item.rawRecord && item.rawRecord.employee_id === profile?.id && item.rawRecord.status === 'disputed' && (
                      <span style={{ fontSize: '11px', color: 'orange', fontWeight: 'bold' }}>Оспаривается</span>
                    )}
                  </div>
                </div>
              ))}
              <div className="salary-detail-total">
                <span>Итого:</span>
                <span>{formatMoney(salaryDetailModal.items.reduce((s, i) => s + (i.isNegative ? -i.amount : i.amount), 0))}</span>
              </div>
            </div>
          )}
        </div>
      )}
    </Modal>
  )
}
